import {FC, useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {FormPageHeader, FormPageFooter} from "@components/falcon/common/forms";
import {RefTargetBaseInfoBlock} from "../forms";
import {RefTargetFormValues} from "../forms/refTargetBaseInfoBlock";

interface TargetFormProps {
    initialValues: RefTargetFormValues;
    onSubmit: (values: RefTargetFormValues) => Promise<any>;
    editForm?: boolean;
    title: string;
    cancelUrl: string;
}

const TargetForm: FC<TargetFormProps> = ({
    initialValues,
    onSubmit,
    editForm,
    title,
    cancelUrl
}) => {

    const validationSchema = useMemo(() => Yup.object<RefTargetFormValues>({
        goalId: Yup.string()
            .required(),
        isActive: Yup.boolean()
            .required()
    }), []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form>
                <Row className="g-3">
                    <Col lg={12}>
                        <FormPageHeader title={title} />
                    </Col>
                    <Col lg={12}>
                        <RefTargetBaseInfoBlock editForm={editForm} />
                    </Col>
                    <Col>
                        <FormPageFooter cancelUrl={cancelUrl} />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

export default TargetForm;
